import { render, staticRenderFns } from "./info-password-reset-page.vue?vue&type=template&id=57240689&scoped=true&"
import script from "./info-password-reset-page.vue?vue&type=script&lang=js&"
export * from "./info-password-reset-page.vue?vue&type=script&lang=js&"
import style0 from "./info-password-reset-page.vue?vue&type=style&index=0&id=57240689&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57240689",
  null
  
)

export default component.exports